<template>
  <div>

    <ProjTab :current_tab="'Komunikacija'" :project_info="proj_data" />
    <div class="upload-dokumenta-button" @click="$refs.newFilePop.openDialog()"
      v-if="is_permission_inside('project.comunication.create')">
      {{ $t('page_2.page_2_5.btn_1') }}
      <div class="upload-icon">
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="16" viewBox="0 0 18 16">
          <g>
            <g>
              <path fill="#fff"
                d="M3.995 5.15a.738.738 0 0 1 .16-.805L8.29.214a.742.742 0 0 1 1.046 0l4.135 4.131a.74.74 0 0 1-.522 1.261h-1.807v5.357a.984.984 0 0 1-.985.983H7.47a.984.984 0 0 1-.984-.983V5.606H4.678a.74.74 0 0 1-.683-.456zm13.749 3.351v3.71C17.744 14.3 16.042 16 13.95 16H3.677a3.796 3.796 0 0 1-3.793-3.79V8.502a.888.888 0 0 1 1.776 0v3.71c0 1.11.904 2.015 2.017 2.015H13.95a2.019 2.019 0 0 0 2.018-2.016V8.501a.887.887 0 0 1 1.776 0z" />
            </g>
          </g>
        </svg>
      </div>
    </div>
    <div class="case-spisi">
      <div class="spisi-left-above">
        <div class="case-spisi-folders-line posta-folders-line">
          <div :class="[
            'section-square',
            'ulazna-posta',
            chosen_type == 0 ? 'active' : '',
          ]" @click="
  setPostFolder(input_mail_id);
chosen_type = 0;
activityFile = null;
">
            <img class="doc-icon" src="@/assets/img/ulazna_posta.svg" />
            <div>{{ $t('page_2.page_2_5.fold_1') }}</div>
          </div>
          <div :class="[
            'section-square',
            'ulazna-posta',
            chosen_type == 1 ? 'active' : '',
          ]" @click="
  setPostFolder(output_mail_id);
chosen_type = 1;
activityFile = null;
">
            <img class="doc-icon" src="@/assets/img/izlazna_posta.svg" />
            <div>{{ $t('page_2.page_2_5.fold_2') }}</div>
          </div>
          <div class="section-square izlazna-posta" v-if="is_permission_inside('project.comunication.email')">
            <pregled-poste :accessToken="accessToken" :key="accessToken" :ulaz="input_mail_id" :izlaz="output_mail_id" :radni_id = "proj_data.root_radni" :popratni_id = "proj_data.root_popratni"
              @refresh-view="resetFileView()" ></pregled-poste>
          </div>
        </div>
      </div>
    </div>
    <div>
      <div class="case-spisi">
        <div class="file-switch-wrapp" @click="toggleFileView">
          <button class="file-switch-view">
            <span class="line"></span>
            <span class="line"></span>
            <span class="line"></span>
            <span class="line"></span>
            <span class="sr-only">Toggle
              menu</span>
          </button>
          {{ getViewTypeText }}
        </div>
      </div>
      <TreeViewerVue v-if="inherit_data.folder_id != null && active_view_type == 0" :key="treemenu_counter"
        :group_type="1" :duplicatable="true" permission_starter="project.comunication" :folder_id="inherit_data.folder_id"
        :group_url="inherit_data.group_url" @loaded-docs="getDocs" :all_files_rec="all_files_rec" view_name="radni"
        :movable="false" @uploadStyling="uploadStyling"
        :enable_preview_modal="true" @preview-file="openPreview"></TreeViewerVue>
      <BlockViewer v-if="inherit_data.folder_id != null && active_view_type == 1" :key="treemenu_counter"
        :group_type="1" :duplicatable="true" permission_starter="project.comunication" :folder_id="inherit_data.folder_id"
        :group_url="inherit_data.group_url" @loaded-docs="getDocs" :all_files_rec="all_files_rec" view_name="radni"
        :movable="false" @uploadStyling="uploadStyling"
        :enable_preview_modal="true" @preview-file="openPreview"></BlockViewer>
    </div>
    <v-dialog v-model="delete_screen" width="564px">
      <v-card color="universal-vcard">
        <div class="universal-vdialog-title">
          {{ $t("page_2.page_2_4.delete_pop.file_title") }}
        </div>
        <div class="vdialog-buttons-wrapper wrapper-three-buttons">
          <div class="universal-vdialog-button vbutton-secondary" @click="delete_screen = false"> {{ $t("repetitive.cancel") }} </div>
          <div class="universal-vdialog-button vbutton-primary" @click="deleteFile(activityFile.id)"> {{ $t("page_2.page_2_4.delete_pop.btn_2") }} </div>
        </div>
      </v-card>
    </v-dialog>
    <v-dialog v-model="upload_fold_model" max-width="400">
      <v-card>
        <v-card-title class="text-h5">
          {{ $t("upload_popup.choose_folder") }}
        </v-card-title>
        <tree-folders :key="refresher" :depth="0" :item="all_files_rec" :accessToken="accessToken"
          @node-click="setUploadFolder" :smjer="smjer"></tree-folders>
        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="blue darken-1" text @click="delete_screen = false">
            {{ $t("upload_popup.choose") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="newFolderPop" width="564px">
      <v-card color="universal-vcard">
        <div class="universal-vdialog-title">
          {{ $t("upload_popup.new_folder") }}
        </div>
        <v-text-field class="universal-vdialog-textfield" label="Naziv foldera" v-model="newDirectoryName">
        </v-text-field>
        <div class="vdialog-buttons-wrapper">
          <div class="universal-vdialog-button vbutton-secondary" @click="newFolderPop = false">{{ $t("repetitive.cancel") }} </div>
          <div class="universal-vdialog-button vbutton-primary" @click="createFolder()"> {{ $t("upload_popup.create") }} </div>
        </div>
      </v-card>
    </v-dialog>

    <sharepoint-file-upload ref="newFilePop" allowedFiles=".pdf" @refresh="resetFileView"  :folder_structure="all_files_rec" :group_id="inherit_data.group_url"  :spis_id="inherit_data.folder_id"/>
    <v-dialog v-model="renameFilePop" width="564px">
      <v-card color="universal-vcard">
        <div class="universal-vdialog-title" v-if="activityFile">
          {{ $t("page_2.page_2_7.rename_pop.title") }}
        </div>
        <v-text-field class="universal-vdialog-textfield" label="Naziv bez nastavka" v-model="new_file_name">
        </v-text-field>
        <div class="vdialog-buttons-wrapper">
          <div class="universal-vdialog-button vbutton-secondary" @click="renameFilePop = false"> {{ $t("repetitive.cancel") }} </div>
          <div class="universal-vdialog-button vbutton-primary" @click="renameFile()"> {{ $t("page_2.page_2_7.rename_pop.btn_2") }} </div>
        </div>
      </v-card>
    </v-dialog>
    <v-overlay :value="overlay">
      <div>Preuzimanje dokumenta u tijeku</div>
      <v-progress-linear color="light-blue darken-4" height="20" :value="overlay_progress" striped></v-progress-linear>
    </v-overlay>
    <v-dialog v-model="$store.state.spis_overlay_open" width="300">
      <DataLoader :is_on="pic_loading" />
      <div id="f-u-vuetify"></div>
      <img v-show="!pic_loading"
        :src="$store.state.spis_active_pic != null && $store.state.spis_active_pic.thumbnails.length > 0 ? $store.state.spis_active_pic.thumbnails[0].large.url : ''"
        @load="onImgLoad">
    </v-dialog>
    <v-snackbar v-model="snackbar_move" :timeout="snackTimeout" color="snack-custom-dark-blue" elevation="24">
      {{ snackText }}
      <div v-for="(od, key) in odbacene" :key="key">{{ od }}</div>
      <template v-slot:action="{ attrs }">
        <v-btn color="white" text v-bind="attrs" @click="snackbar_move = false">
          {{$t("repetitive.okay")}}
        </v-btn>
      </template>
    </v-snackbar>
    <!-- create new folder popup -->

    <FilePreviewModal
      v-model="previewVisible"
      :fileItem="previewFile"
      :groupId="inherit_data.group_url"
    />
  </div>
</template>

<script>
import share from "@/apiCallers/promise_handler_db/sharepoint";
import auth from "@/services/auth";
import $ from "jquery";
import gsap from "gsap";
import TreeMenu from "@/components/generalComponents/TreeMenu.vue";
import moment from "moment";
import TreeFolders from "@/components/generalComponents/TreeFolders.vue";
import draggable from "vuedraggable";
import graph from "@/services/graph.js";
import PregledPoste from "@/components/caseComponents/PregledPoste.vue";
import ProjTab from "@/components/projectComponents/ProjTab.vue"
import permissioner from "@/services/permissioner.js"
import { getProjData } from "@/router/project/handler"
import DataLoader from '@/components/generalComponents/DataLoader'
import TreeViewerVue from "../../../../components/generalComponents/FileViewer/TreeViewer.vue";
import BlockViewer from "../../../../components/generalComponents/FileViewer/BlockViewer.vue";
import SharepointFileUpload from '../../../../components/fileManagement/SharepointFileUpload.vue';
import FilePreviewModal from "@/components/generalComponents/FileViewer/FilePreviewModal.vue";




export default {
  components: {
    TreeMenu,
    TreeFolders,
    draggable,
    ProjTab,
    PregledPoste,
    DataLoader,
    TreeViewerVue,
    BlockViewer,
    SharepointFileUpload,
    FilePreviewModal
  },
  data() {
    return {
      previewVisible: false,
      previewFile: null,
      inherit_data: {
        folder_id: null,
        group_url: null,
      },
      active_view_type: 0,
      //moving 
      moving_file: {
        parentReference: {
          id: "",
        },
        name: "",
      },
      //upload folder start
      newDirectoryName: "",
      newDirectoryParentId: "",
      newFolderPop: false,
      uploadNode: null,
      //upload folder end
      overlay: false,
      overlay_progress: 0,
      popis_preuzimanja_spisa: [],
      newFilePop: false,
      upload_fold_model: false,
      selected_upload_folder: null,
      order_by_tekst: this.$t("page_2.page_2_3.f_desc"),
      side_spis_view: false,
      selected_spis: {},
      treemenu_counter: 1,
      smjer: true,
      delete_screen: false,
      trigg: true,
      activityFile: null,
      multi_file_list: [],
      tree: {},
      accessToken: "",
      loading: false,
      selectedFolder: null,
      selectedFile: "",
      progress: 0,
      folders: [],
      proj_data: { broj_projekta: "" },
      filelist: [],
      snackbar: false,
      snackTimeout: 10000,
      snackText: '',
      odbacene: [],
      //ulazna i izlazna pošta
      input_mail_id: "",
      output_mail_id: "",
      chosen_type: 0,
      is_waiting_on_insert: false,
      active_mail_type: "",

      all_files_rec: null,
      are_files_loaded: false,
      refresher: 1,

      new_file_name: "",
      renameFilePop: false,


      permission: {
        create: true,
        update: true,
        delete: true,
        read: true
      },
      folder_name: '',
      anim_duration: 0.5,
      overlay_thumbnail: false,
      pic_loading: true,
      snackbar_move: false,
    };
  },
  async created() {
    this.accessToken = this.$store.state.aToken

    await getProjData(this.$route.params.uid).then(async (response) => {
      this.proj_data = response;
      this.setPostFolder(this.proj_data.root_ulazna);

      var validator_array = this.proj_data.connect_project_odvjetnik.filter(
        (p) => {
          return this.$store.state.logged_in_user.uid === p.odvjetnik.uid;
        }
      );

      // treba nadograditi sa novim user_role logikom
      if (validator_array.length == 0 && this.$store.state.logged_in_user.user_role.id != 1) {
        this.$router.push({ name: "NotPartOfCase" });
      }

      else if (this.$store.state.logged_in_user.user_role.id != 1) {
        permissioner.save_project_permission(this.$route.params.uid, validator_array[0].project_odvjetnik_status.project_permission.map((p) => p.permission_id));
      }


      this.input_mail_id = this.proj_data.root_ulazna;
      this.output_mail_id = this.proj_data.root_izlazna;
    });
  },
  watch: {
    "$store.state.spis_overlay_open": {
      handler: function () {
        if (!this.$store.state.spis_overlay_open) {
          this.pic_loading = true;
        }
      }
    }
  },
  computed: {
    getViewTypeText: function () {
      if (this.active_view_type == 0) {
        return this.$t("billing_page.tree_view")
      } else {
        return this.$t("billing_page.block_view")
      }
    }
  },
  methods: {
    openPreview(file) {
      this.previewFile = file;
      this.previewVisible = true;
    },
    getDocs: function (all_files) {
      this.all_files_rec = all_files;
    },
    toggleFileView: function () {
      if (this.active_view_type == 0) {
        this.active_view_type = 1;
      } else {
        this.active_view_type = 0;
      }
      $(".file-switch-view").toggleClass("is-active")
    },
    onImgLoad() {
      this.pic_loading = false;
      setTimeout(() => {
        var getFuckingParent = document.getElementById("f-u-vuetify");
        $(getFuckingParent.parentElement).addClass('setDialogWidth');
      }, 10);
    },
    closeDetalji() {
      this.activityFile = null;
      this.multi_file_list = [];
      $('.inside-folder').removeClass("eye_clicked");
    },
    is_permission_inside(wanted_permission, assistent_check = true) {
      return permissioner.check_project_permission(wanted_permission)
    },
    folderHover(node) {
      if (node == null) {
        this.moving_file.parentReference.id = "";
        this.moving_file.name = "";
      } else {
        this.moving_file.parentReference.id = node.id;

      }
    },

    openRenamePop() {
      var full_old_name = this.activityFile.name.split(".");
      full_old_name.pop();
      this.new_file_name = full_old_name.join(".");
      this.renameFilePop = true;



    },
    async setPostFolder(mail_type) {
      this.inherit_data.group_url = this.$route.params.uid;
      this.inherit_data.folder_id = mail_type;
      this.active_mail_type = mail_type;
      this.selected_upload_folder = null;
      await this.resetFileView();
      if ($('#tree-menu').height() > 960) {
        this.anim_duration = 0.4;
      }
      else {
        this.anim_duration = $('#tree-menu').height() * 0.00045;
      }
      gsap.fromTo('#tree-menu', this.anim_duration, { height: 0 }, { height: 'auto', ease: "none" });
    },

    //Rename activity file
    renameFile() {
      var idx_ext = this.activityFile.name.split(".").length - 1;
      var extension = this.activityFile.name.split(".")[idx_ext];
      var new_name_ext = this.new_file_name + "." + extension;

      console.log("Old name", this.activityFile.name);
      console.log("New name", new_name_ext);
      const driveItem = {
        name: new_name_ext,
      };
      share.renameSingleDoc(this.accessToken, this.$route.params.uid, this.activityFile.id, driveItem).then((resp) => {
        this.activityFile = null;
        this.multi_file_list = [];
        this.renameFilePop = false;
        this.new_file_name = ""
        this.resetFileView()
      })

    },
    moveFile(node) {
      this.odbacene = [];
      this.snackbar_move = false;
      if (this.multi_file_list.length == 0) {
        this.multi_file_list.push(node);
      }
      console.log(this.multi_file_list)
      for (let i = 0; i < this.multi_file_list.length; i++) {
        let active_move_file = this.multi_file_list[i];
        console.log(this.multi_file_list[i], active_move_file)
        if (active_move_file.parentReference.id != this.moving_file.parentReference.id && this.moving_file.parentReference.id != "") {
          this.moving_file.name = active_move_file.name
          var path = "/drive/items/" + active_move_file.id;

          share
            .moveDriveItem(
              this.accessToken,
              this.$route.params.uid,
              active_move_file.parentReference.id,
              path,
              this.moving_file
            )
            .then(() => {
              if (i + 1 == this.multi_file_list.length) {
                this.multi_file_list = []
                setTimeout(async () => {
                  this.resetFileView();
                }, 200);
              }
            })
            .catch((err) => {
              if (err.response.status == 409) {
                this.odbacene.push(active_move_file.name);
                this.snackText =
                  "Sljedeće datoteke nisu prenesene jer u odredišnom folderu postoji datoteka sa istim nazivom:";
                this.snackbar_move = true;
              }
              else console.log(err)
            })
            .finally(() => {
              if (i + 1 == this.multi_file_list.length) {
                this.multi_file_list = []
                setTimeout(async () => {
                  this.resetFileView();
                }, 200);
              }
            });
        } else {
          if (i + 1 == this.multi_file_list.length) {
            this.multi_file_list = []
            setTimeout(async () => {
              this.resetFileView();
            }, 200);
          }
        }
      }

    },

    //dodajem klasu na upload wrapper da ga mogu lakše modificirati, jebem te vuetify
    uploadStyling() {
      this.newFilePop = true;
      setTimeout(function () {
        var upl = document.getElementById("main-file-upload");
        $(upl.parentElement.parentElement).addClass(
          "file-upload-dialog-wrapper"
        );
        $(upl.parentElement).addClass("main-file-upload-wrapper");
        $(upl.nextSibling).addClass("spis-megawrapper-parent");
        $('.spis-megawrapper').removeClass('active');
        $('.main-file-upload-wrapper').find('.spis-megawrapper:first').click();
      }, 100);
    },

    //RESET OF DATA VIEW
    async resetFileView() {
      this.newFilePop = false;
      this.treemenu_counter++;
      this.filelist = [];
    },

    //COLLECT ALL PDF-s and send them into mergeing process
    async spisToPDF() {
      if (this.pdf_mergeing == false) {
        this.pdf_mergeing = true;
        await share
          .mergeFiles(this.pdf_merge_file_list, 0, Date.now())
          .then(async (response) => {
            let tmp_file_name = response.data;

            await share
              .mergeFilesFinal(0, tmp_file_name)
              .then(async (resp) => {
                var newBlob = new Blob([resp.data], {
                  type: "application/pdf",
                });
                var data = window.URL.createObjectURL(newBlob);

                var link = document.createElement("a");
                link.href = data;
                link.download = this.selected_spis.ime + ".pdf";
                link.click();
                setTimeout(function () {
                  // For Firefox it is necessary to delay revoking the ObjectURL
                  window.URL.revokeObjectURL(data);
                }, 100);
                this.pdf_mergeing = false;
              })
              .then(async () => {
                await share.mergeFilesClear(tmp_file_name);
              });
          });
      }
    },
    // Add some visual fluff to show the user can drop its files
    dragover(event) {
      event.preventDefault();
      if (!event.currentTarget.classList.contains("bg-green-300")) {
        event.currentTarget.classList.remove("bg-gray-100");
        event.currentTarget.classList.add("bg-green-300");
        gsap.to(".loading-spinner", 0, { display: "block" });
        gsap.to(".loading-spinner", 0.5, { opacity: 1 });
        gsap.to(".drop-document-area", 0.5, {
          filter: "blur(3px)",
          opacity: 0.7,
        });
      }
    },
    // Clean up after cursor leaves
    dragleave(event) {
      event.currentTarget.classList.add("bg-gray-100");
      event.currentTarget.classList.remove("bg-green-300");
      gsap.to(".loading-spinner", 0.5, { opacity: 0 });
      gsap.to(".drop-document-area", 0.5, { filter: "none", opacity: 1 });
    },
    //EVENT following dropping the files in area
    drop(event) {
      event.preventDefault();
      this.$refs.file.files = event.dataTransfer.files;
      this.onChange(); // Trigger the onChange event manually
      // Clean up
      event.currentTarget.classList.add("bg-gray-100");
      event.currentTarget.classList.remove("bg-green-300");
      //
      gsap.to(".loading-spinner", 0.5, { opacity: 0 });
      gsap.to(".drop-document-area", 0.5, { filter: "none", opacity: 1 });
    },
    openSelectedFiles() {
      for (let i = 0; i < this.multi_file_list.length; i++) {
        window.open(this.multi_file_list[i].webUrl)
      }
    },
    // Reaction to event drop, that checks and controls all data
    onChange() {
      this.snackbar = false;
      //check all the inserted files and remove all that don't comply with pdf format START
      let tmp_file_list = [...this.$refs.file.files];
      let filt_tmp_file_list = tmp_file_list.filter((file) => file.size < 57671680);
      const num_odbacenih = tmp_file_list.length - filt_tmp_file_list.length;
      if (num_odbacenih != 0) {
        this.snackbar = true;
        this.odbacene = tmp_file_list.filter((file) => file.size >= 57671680);
        this.snackText =
          "Zbog ograničenja Sharepoint-a odbačene su sljedeće datoteke veće od 55MB:";
      }
      tmp_file_list = filt_tmp_file_list;

      let pdf_tmp_file_list = tmp_file_list.filter((p) => {
        let tmp_name_list = p.name.split(".");
        return tmp_name_list[tmp_name_list.length - 1].toLowerCase().includes("pdf");
      });
      //check all the inserted files and remove all that don't comply with pdf format END
      const len_dif = tmp_file_list.length - pdf_tmp_file_list.length;
      if (len_dif > 0) {
        this.odbacene = [];
        this.snackbar = true;
        this.snackText =
          "Odbačeno je " + len_dif + " datoteka koje nisu PDF formata.";
      }
      tmp_file_list = pdf_tmp_file_list;
      if ([...this.$refs.file.files].length)
        this.filelist = this.filelist.concat(tmp_file_list);
    },
    //Remove file from list on X
    closePrint() {
      document.body.removeChild(this.__container__);
    },

    //
    setPrint() {
      contentWindow.__container__ = this;
      contentWindow.onbeforeunload = this.closePrint();
      contentWindow.onafterprint = this.closePrint();
      contentWindow.focus(); // Required for IE
      contentWindow.print();
    },
    async reverseSmjer() {
      this.smjer = !this.smjer;
      // TweenMax.to('.open-folder-line-sort svg', 1, {rotation:360, ease:Linear.easeNone, repeat:-1})

      gsap.to('#tree-menu', this.anim_duration, { height: 0, ease: "none" });
      setTimeout(async () => {
        if (this.smjer) {
          gsap.to('.svg-to-rotate', 0, { rotation: 0 });
          this.order_by_tekst = this.$t("page_2.page_2_3.f_desc");
        } else {
          gsap.to('.svg-to-rotate', 0, { rotation: 180 });
          this.order_by_tekst = this.$t("page_2.page_2_3.f_asc");
        }
        await this.resetFileView();
        gsap.fromTo('#tree-menu', this.anim_duration, { height: 0 }, { height: 'auto', ease: "none" });
      }, this.anim_duration * 1000);
    },
    openFile(linkToFile) {
      window.open(linkToFile);
    },
    deleteFile(fileId) {
      this.delete_screen = false;
      var path = "/drive/items/" + fileId;
      share
        .deleteFile(this.accessToken, this.$route.params.uid, path)
        .then(() => {
          this.activityFile = null;
          this.multi_file_list = [];
          this.resetFileView();
        });
    },
    logClick(node) {
      this.activityFile = node;
      this.multi_file_list = [];
      this.multi_file_list.push(node)
      // this.getPreview();
      this.side_spis_view = false;
      //animacija za detalje spisa - da se signalizira da se nešto promijenilo
      gsap.fromTo(".detalji-spisa", 0.3, { y: 50 }, { y: 0 });
    },
    setMultiFileSelection(node) {
      this.activityFile = null;
      // this.getPreview();
      this.side_spis_view = true;
      //animacija za detalje spisa - da se signalizira da se nešto promijenilo
      gsap.fromTo(".detalji-spisa", 0.3, { y: 50 }, { y: 0 });

      let tmp_index = this.multi_file_list.findIndex((p) => {
        return p.id == node.id;
      });
      if (tmp_index == -1) {
        console.log("Datoteka nije u popisu ", tmp_index)
        this.multi_file_list.push(node);
      } else {
        console.log("Datoteka je u popisu ", this.multi_file_list,)
        $('#single-file-' + node.id).removeClass("eye_clicked");
        this.multi_file_list.splice(tmp_index, 1);
      }

    },

    // CREATE FOLDER FUNCTIONS START
    handleFolderCreateFromFile(node) {
      if (this.is_permission_inside("project.comunication.create")) {
        let direcNameArray = node.name.split(".");
        if (direcNameArray.length > 1) {
          direcNameArray.pop();
        }
        let tmp_dir_name = direcNameArray.join("");
        this.newDirectoryName = tmp_dir_name;
        this.newFolderPop = true;
        this.newDirectoryParentId = node.parentReference.id;
        this.uploadNode = node;
      }
    },
    //CREATE NEW FOLDER WHEN CLICKED ON ANOTHER FOLDER
    handleFolderCreateFromFolder(node) {
      if (this.is_permission_inside("project.comunication.create")) {
        this.newDirectoryName = "";
        this.newFolderPop = true;
        this.newDirectoryParentId = node.id;

        this.uploadNode = null;
      }
    },
    //Connection to api that sends all necessery identifications and nodes to sharepoint site onedrive
    createFolder() {
      share
        .createFolderDocs(
          this.accessToken,
          this.$route.params.uid,
          this.newDirectoryParentId,
          this.newDirectoryName
        )
        .then((resp) => {
          if (this.uploadNode != null) {
            var path = "/drive/items/" + this.uploadNode.id;
            var tmpDriveItem = {
              parentReference: {
                id: resp.data.id,
              },
              name: this.uploadNode.name,
            };

            share
              .moveDriveItem(
                this.accessToken,
                this.$route.params.uid,
                resp.data.id,
                path,
                tmpDriveItem
              )
              .then(() => {
                this.resetFileView();
              });
          } else {
            this.resetFileView();
          }
          this.newFolderPop = false;
        });
    },
    // CREATE FOLDER FUNCTIONS END

    //inside upload form set the folder id
    setUploadFolder(node) {
      this.selected_upload_folder = node.id;
      console.log("New selected upload folder", node);
    },

    previewFiles() {
      var input = document.getElementById("myFiles");
      var file = input.files[0];
      share.addDocumentInSpis(
        this.accessToken,
        this.$route.params.uid,
        this.selectedFolder,
        file
      );
    },
    async addNewUploadFile() {
      if (this.filelist.length != 0) {
        const formData = new FormData();
        this.filelist.forEach((fl) => {
          console.log(fl);
          formData.append("files", fl);
        });
        if (this.selected_upload_folder == null) {
          if (this.chosen_type == 0) {
            this.selected_upload_folder = this.input_mail_id;
          }
          else {
            this.selected_upload_folder = this.output_mail_id;
          }
        }
        formData.append("token", this.accessToken);
        formData.append("groupId", this.$route.params.uid);
        formData.append("sid", this.selected_upload_folder);
        // formData.append("name", esc_filename);
        // appending file
        this.file_upload_text = "Uploading...";
        this.is_waiting_on_insert = true;
        await share
          .addDocumentInSpis(formData)
          .then(() => {
            this.is_waiting_on_insert = false;
            this.file_upload_text = "Upload";
            this.resetFileView();
            document.getElementById("assetsFieldHandle").value = "";

          })
          .catch((err) => {
            this.is_waiting_on_insert = false;
            this.file_upload_text = "Upload";
            document.getElementById("assetsFieldHandle").value = "";

          });
      }
    },
    //PUSH ROUTE TO CASE SPIS BASED ON ID
    routeToSpis(sid) {
      this.$router.push("/case/" + this.$route.params.uid + "/spisi/" + sid);
      this.side_spis_view = true;
      this.activityFile = null;
    },

    //GET ALL DOCS IN DRIVE BASED ON drive id
    getAllDocsById(sid) {
      var ret_files = [];
      share
        .getDocumentsInSpis(
          this.accessToken,
          this.$route.params.uid,
          sid,
          this.smjer
        )
        .then((response) => {
          response.data.forEach((dat) => {
            ret_files.push(dat);
          });
        });

      return ret_files;
    },
    // DELETE ALL FILES IN SPIS
    deleteFileInSpis(file) {
      this.filelist = this.filelist.filter((f) => f != file);
    },
    // RETURN APPROPRIATE FILE ICON
    returnFileType(file_name) {
      var idx_ext = file_name.split(".").length - 1;
      var extension = file_name.split(".")[idx_ext].toLowerCase();
      var return_val = require("@/assets/img/doc_icon.svg");
      switch (extension) {
        case "docx":
          return_val = require("@/assets/img/doc_icon.svg");
          break;
        case "doc":
          return_val = require("@/assets/img/doc_icon.svg");
          break;
        case "pdf":
          return_val = require("@/assets/img/pdf_icon.svg");
          break;
        case "csv":
          return_val = require("@/assets/img/xls_icon.svg");
          break;
        case "xls":
          return_val = require("@/assets/img/xls_icon.svg");
          break;

        default:
          return_val = require("@/assets/img/doc_icon.svg");
          break;
      }
      return return_val;
    },
    //SWITCH TO NEW VIEW BY ROUTE
    switchTab(nastavak) {
      this.$router.push("/case/" + this.$route.params.uid + "/" + nastavak);
    },
    //APPROPRIATE DATE TIME FORMAT FOR DISPLAY
    switchDate(inData) {
      return moment(inData.toString()).format("lll");
    },
    //RETURNS FOLDER IN PARRENT DIRECTORY
    getfoldersById(sid) {
      var ret_fold = [];
      share
        .getDocumentsInSpis(
          this.accessToken,
          this.$route.params.uid,
          sid,
          this.smjer
        )
        .then((response) => {
          response.data.forEach((dat) => {
            if (dat.folder != undefined) {
              ret_fold.push(dat);
            }
          });
        });
      return ret_fold;
    },

    //GET INITIAL
    async get_recursive_data(id) {
      var ret_fold = [];
      this.accessToken = this.$store.state.aToken
      await graph
        .getFileChildren(this.$route.params.uid, id)
        .then((response) => {
          if (response.value.length > 0) {
            let tmp_arr_files = response.value.filter((p) => p.name.toString().toLowerCase().endsWith(".pdf") || p.folder != undefined);
            if (this.smjer === true) {
              tmp_arr_files.sort(function (a, b) {
                return new Date(b.createdDateTime) - new Date(a.createdDateTime);
              });
            } else {
              tmp_arr_files.sort(function (a, b) {
                return new Date(a.createdDateTime) - new Date(b.createdDateTime);
              });
            }
            tmp_arr_files.forEach(async (dat) => {
              let tmp_ret_item = {
                item: dat,
                children: [],
              };
              if (dat.folder != undefined) {
                tmp_ret_item.children = await this.get_recursive_data(dat.id);
              } else {
                this.pdf_merge_file_list.push(
                  dat["@microsoft.graph.downloadUrl"]
                );
              }
              ret_fold.push(tmp_ret_item);
            });
          }
        });
      return ret_fold;
    },
    async getRootSpisFile(sid) {
      let tmp_first = {
        item: {},
        children: [],
      };
      await graph
        .getSingleFile(this.$route.params.uid, sid)
        .then(async (response) => {
          tmp_first.item = response;
        });
      return tmp_first;
    },
  },
  mounted() {
    document.body.classList.add("posta-page");
    //za hendlanje desnog spis detalji prozorčića
    setTimeout(function () {
      $(window).scroll(function () {
        var brojDokumenata = $(".spis-megawrapper").length;
        var h = document.documentElement,
          b = document.body,
          st = "scrollTop",
          sh = "scrollHeight";
        var percent =
          ((h[st] || b[st]) / ((h[sh] || b[sh]) - h.clientHeight)) * 100;
        if (percent > 20 || window.matchMedia("(min-width: 1199px) and (max-width: 1570px)").matches) {
          gsap.to(".spisi-right", 0.3, { marginTop: "-12rem" });
        }
        if (percent < 20) {
          gsap.to(".spisi-right", 0.3, { marginTop: "5rem" });
        }
      }); //end scroll function
    }, 1700);
  },
  destroyed() {
    document.body.classList.remove("posta-page");
    setTimeout(() => {
      $(window).off();
    }, 1700);
  },
};
</script>

<style>

</style>